module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-02.413528e7.svg";